import React from 'react';
import PointsMap from '../locations/PointsMap';

export default function PlacesMap({ places }) {
  return <PointsMap points={(places || []).filter(x => x.coordinates)} />;
}
